/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { Route, Switch, useHistory } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import { useUser } from 'contexts/User';
import { UserManagementPage } from 'pages';
import SignInPage from 'pages/SignIn';
// import TransportManagementPage from 'pages/TransportManagement';
import FunctionPage from 'pages/UserManagement/FuntionPage';
import GroupsPage from 'pages/UserManagement/GroupPage';
import JobTitlePage from 'pages/UserManagement/TitlePage';
import MappingJobTitlePage from 'pages/UserManagement/MappingJobTitle';
import { CategoryManagementPage } from 'pages/CategoryManagement';
import CategoryInfoStepPage from 'pages/CategoryManagement/AddCategory/CategoryInfoStepPage';
import ProductListStepPage from 'pages/CategoryManagement/AddCategory/ProductListStepPage';
import ApproveStepPage from 'pages/CategoryManagement/AddCategory/ApproveStepPage';
import ProfilePage from 'pages/Profile/ProfilePage';
import ProductListPage from 'pages/Product/ProductPageList';
import ProductDetailPage from 'pages/ProductDetaill/ProductDetailPage';
import DepartmentApproval from 'pages/Setting/DepartmentApproval/DepartmentApproval';
import EditApproval from 'pages/Setting/DepartmentApproval/EditApproval';
import CreateApproval from 'pages/Setting/DepartmentApproval/CreateApproval';
import ApprovalDetail from 'pages/Setting/DepartmentApproval/ApprovalDetail';
import BrandPage from 'pages/Setting/Brand/BrandPage';
import AddBrandPage from 'pages/Setting/Brand/AddBrandPage';
import BrandDetailPage from 'pages/Setting/Brand/BrandDetailPage';
import BrandEditlPage from 'pages/Setting/Brand/BrandEditPage';
import CategoryInfoPage from 'pages/CategoryManagement/CategoryInfo/CategoryInfoPage';
import CabinetPage from 'pages/Setting/Cabinet/CabinetPage';
import CreateCabinet from 'pages/Setting/Cabinet/CreateCabinet';
import DeclareCartInfo from 'pages/Cart/DeclareCart/DeclareCartInfo';
import DeclareCartProducts from 'pages/Cart/DeclareCart/DeclareCartProducts';
import CartList from 'pages/Cart/CartList/CartList';
import CartDetailPage from 'pages/Cart/CartList/CartDetail';
import ProductUpdatePage from 'pages/ProductUpdate/ProductUpdatePage';
import CreateCartInfo from 'components/Modules/Cart/PreOrder/CreateCartInfo';
import CreateCartReview from 'components/Modules/Cart/PreOrder/CreateCartReview';
import DeclareCartReviewInfo from 'pages/Cart/DeclareCart/DeclareCartReviewInfo';
import PreOrderListPage from 'pages/Cart/PreOrder/PreOrderList';
import EditCartPage from 'pages/Cart/PreOrder/EditPreOrder';
import OderCartList from 'pages/Cart/PreOrder/OderCartList';
import ChtCartList from 'pages/Cart/Order/ChtCartList';
import BranchCapital from 'pages/Branch/Allocate/AllocatelistView';
import ChtView from 'pages/Cart/Order/ChtView';
import TvvCartList from 'pages/Cart/Order/TvvCartList';
import Allocatedetails from 'pages/Branch/Allocate/Allocatedetails';
import TVVCheckCart from 'pages/Cart/Order/TVVCheckCart';
import StepDeclare from 'components/Modules/Allocated/AllocateCreate/StepDeclare';
import StepList from 'components/Modules/Allocated/AllocateCreate/StepList';
import PlantAllocateView from 'pages/Branch/PlantAllocate/PlantAllocateView';
import PlantDeclareCreateCabinet from 'components/Modules/Allocated/PlantAllocateDeclare/PlantDeclareCreateCabinet';
import PlantAllocategoodsCreate from 'components/Modules/Allocated/PlantAllocateDeclare/PlantAllocategoodsCreate';
import StoreInfo from 'pages/Branch/StoreInfo/StoreInfo';
import ApproveOrderList from 'pages/Approve/ApproveOrder/ApproveOrderList';
import DeclarePage from 'pages/Declare/DeclarePage';
import DetailApproveOrderList from 'pages/Approve/DetailApproveOrderList/DetailApproveOrderList';
import ListApproveOrder from 'pages/Approve/ApproveOrder/ListApproveOrder';
import ApproveCategoryLits from 'pages/Approve/ApproveCategory/ApproveCategoryLits';
import ApproveCategoryDetail from 'pages/Approve/ApproveCategory/ApproveCategoryDetail';
import RecommendedListDetail from 'pages/Setting/RecommendedList/RecommendedListDetail';
import Step1 from 'components/Modules/Setting/RecommendedList/Step1';
import Step2 from 'components/Modules/Setting/RecommendedList/Step2';
import ApproveDetail from 'pages/Approve/ApproveOrder/ApproveDetail';

const Routes = (): JSX.Element => {
  const { user } = useUser();
  // useEffect(() => {
  //   if (user && user.role && user.role.includes('nguoi_dat_hang')) {
  //     history.push('/product');
  //   } else if (user && user.role && user.role.includes('cua_hang_truong')) {
  //     history.push('/product');
  //   }
  // }, [user, history]);

  // const routes = user?.role.includes('nguoi_dat_hang')
  //   ? [
  //       { path: '/', component: OderCartList },
  //       { path: '/sign-in', component: SignInPage, isPublic: true },

  //       {
  //         path: '/profile',
  //         component: ProfilePage,
  //       },
  //       // {
  //       //   path: '/product',
  //       //   component: ProductListPage,
  //       // },
  //       {
  //         path: '/product/:code',
  //         component: ProductDetailPage,
  //       },
  //       {
  //         path: '/product-update',
  //         component: ProductUpdatePage,
  //       },
  //       {
  //         path: '/product-register',
  //         component: OderCartList,
  //       },
  //       {
  //         path: '/order/tvv-view/:id',
  //         component: TVVCheckCart,
  //       },
  //       {
  //         path: '/order-product-list/create',
  //         component: TvvCartList,
  //       },
  //       {
  //         path: '/declare',
  //         component: DeclarePage,
  //       },
  //     ]
  //   : user?.role.includes('cua_hang_truong')
  //   ? [
  //       { path: '/', component: OderCartList },
  //       { path: '/sign-in', component: SignInPage, isPublic: true },

  //       {
  //         path: '/profile',
  //         component: ProfilePage,
  //       },
  //       // {
  //       //   path: '/product',
  //       //   component: ProductListPage,
  //       // },
  //       {
  //         path: '/product/:code',
  //         component: ProductDetailPage,
  //       },
  //       {
  //         path: '/product-update',
  //         component: ProductUpdatePage,
  //       },
  //       {
  //         path: '/product-register',
  //         component: OderCartList,
  //       },
  //       {
  //         path: '/order/tvv-view/:id',
  //         component: TVVCheckCart,
  //       },
  //       {
  //         path: '/order/cht-view/:id',
  //         component: ChtView,
  //       },
  //       {
  //         path: '/order-product-list/create',
  //         component: TvvCartList,
  //       },
  //       {
  //         path: '/plants-allocate',
  //         component: PlantAllocateView,
  //       },
  //       {
  //         path: '/plants-allocate/createCabinet/:id',
  //         component: PlantDeclareCreateCabinet,
  //       },
  //       {
  //         path: '/plants-allocate/createAllocateGoods/:id',
  //         component: PlantAllocategoodsCreate,
  //       },
  //       // {
  //       //   path: '/branchs-capital',
  //       //   component: BranchCapital,
  //       // },
  //       {
  //         // khi nào lắp API thì thêm ID vào
  //         path: '/branchs-capital-detail',
  //         component: Allocatedetails,
  //       },
  //       {
  //         path: '/branchs-capital-create/declare',
  //         component: StepDeclare,
  //       },
  //       {
  //         path: '/branchs-capital-create/list',
  //         component: StepList,
  //       },
  //       {
  //         path: '/list-approve',
  //         component: ListApproveOrder,
  //       },
  //       {
  //         path: '/detail-approve-order-list',
  //         component: DetailApproveOrderList,
  //       },
  //       {
  //         path: '/approve-order-list',
  //         component: ApproveOrderList,
  //       },
  //       {
  //         path: '/approve-detail',
  //         component: ApproveDetail,
  //       },
  //       {
  //         path: '/declare',
  //         component: DeclarePage,
  //       },
  //     ]
  //   : [
  //       {
  //         path: '/',
  //         component:
  //           user?.plantCode == 1000 ? CategoryManagementPage : OderCartList,
  //       },
  //       { path: '/sign-in', component: SignInPage, isPublic: true },
  //       {
  //         path: '/role-based-auth',
  //         component: UserManagementPage,
  //       },
  //       {
  //         path: '/groups',
  //         component: GroupsPage,
  //         isPublic: true,
  //       },
  //       {
  //         path: '/functions',
  //         component: FunctionPage,
  //       },
  //       {
  //         path: '/job-title',
  //         component: JobTitlePage,
  //       },
  //       {
  //         path: '/mapping-job-title',
  //         component: MappingJobTitlePage,
  //       },
  //       {
  //         path: '/category',
  //         component: user?.plantCode == 1000 ? CategoryManagementPage : null,
  //       },
  //       {
  //         path: '/add-category/category-info-step/:id?',
  //         component: CategoryInfoStepPage,
  //       },
  //       {
  //         path: '/add-category/product-list-step/:id?',
  //         component: ProductListStepPage,
  //       },
  //       {
  //         path: '/add-category/approve-step/:id?',
  //         component: ApproveStepPage,
  //       },
  //       {
  //         path: '/category/:id',
  //         component: CategoryInfoPage,
  //       },
  //       {
  //         path: '/profile',
  //         component: ProfilePage,
  //       },
  //       {
  //         path: '/product',
  //         component: user?.plantCode == 1000 ? ProductListPage : null,
  //       },
  //       {
  //         path: '/product/:code',
  //         component: ProductDetailPage,
  //       },
  //       {
  //         path: '/department-approval',
  //         component: DepartmentApproval,
  //       },
  //       {
  //         path: '/department-approval/edit/:id',
  //         component: EditApproval,
  //       },
  //       {
  //         path: '/department-approval/addnew',
  //         component: CreateApproval,
  //       },
  //       {
  //         path: '/department-approval/detail/:id',
  //         component: ApprovalDetail,
  //       },
  //       {
  //         path: '/brand',
  //         component: BrandPage,
  //       },
  //       {
  //         path: '/brand/add-brand',
  //         component: AddBrandPage,
  //       },
  //       {
  //         path: '/brand/edit',
  //         component: BrandEditlPage,
  //       },
  //       {
  //         path: '/brand/details',
  //         component: BrandDetailPage,
  //       },
  //       {
  //         path: '/branch-cabinet',
  //         component: CabinetPage,
  //       },
  //       {
  //         path: '/branch-cabinet/create',
  //         component: CreateCabinet,
  //       },
  //       {
  //         path: '/recommended-list',
  //         component: RecommendedListDetail,
  //       },
  //       {
  //         path: '/recommended-list/edit/step1',
  //         component: Step1,
  //       },
  //       {
  //         path: '/recommended-list/edit/step2',
  //         component: Step2,
  //       },
  //       {
  //         path: '/declare-cart-info',
  //         component: DeclareCartInfo,
  //       },
  //       {
  //         path: '/declare-cart-product/:id/:pof_type_code',
  //         component: DeclareCartProducts,
  //       },
  //       {
  //         path: '/declare-cart-review-info/:id',
  //         component: DeclareCartReviewInfo,
  //       },
  //       {
  //         path: '/cart-list',
  //         component: CartList,
  //       },
  //       {
  //         path: '/cart-details/:id',
  //         component: CartDetailPage,
  //       },
  //       {
  //         path: '/preorder-create-order',
  //         component: CreateCartInfo,
  //       },
  //       {
  //         path: '/preorder-create-review',
  //         component: CreateCartReview,
  //       },
  //       {
  //         path: '/product-update',
  //         component: ProductUpdatePage,
  //       },
  //       {
  //         path: '/product-register',
  //         component: OderCartList,
  //       },
  //       {
  //         path: '/order/tvv-view/:id',
  //         component: TVVCheckCart,
  //       },
  //       {
  //         path: '/preorder',
  //         component: PreOrderListPage,
  //       },
  //       {
  //         path: '/preorder/edit/:plantId/:cartRegisterId',
  //         component: EditCartPage,
  //       },
  //       {
  //         path: '/order',
  //         component: ChtCartList,
  //       },
  //       {
  //         path: '/branchs-capital',
  //         component: user?.role.includes('admin') ? BranchCapital : null,
  //       },
  //       {
  //         path: '/plants-allocate',
  //         component: PlantAllocateView,
  //       },
  //       {
  //         path: '/plants-allocate/createCabinet/:id',
  //         component: PlantDeclareCreateCabinet,
  //       },
  //       {
  //         path: '/plants-allocate/createAllocateGoods/:id',
  //         component: PlantAllocategoodsCreate,
  //       },
  //       {
  //         path: '/store-info',
  //         component: StoreInfo,
  //       },
  //       {
  //         // khi nào lắp API thì thêm ID vào
  //         path: '/branchs-capital-detail',
  //         component: Allocatedetails,
  //       },
  //       {
  //         path: '/branchs-capital-create/declare',
  //         component: StepDeclare,
  //       },
  //       {
  //         path: '/branchs-capital-create/list',
  //         component: StepList,
  //       },
  //       {
  //         path: '/order/cht-view/:id',
  //         component: ChtView,
  //       },
  //       {
  //         path: '/order-product-list/create',
  //         component: TvvCartList,
  //       },
  //       {
  //         path: '/approve-order-list',
  //         component: ApproveOrderList,
  //       },
  //       {
  //         path: '/approve-detail',
  //         component: ApproveDetail,
  //       },
  //       {
  //         path: '/declare',
  //         component: DeclarePage,
  //       },
  //       {
  //         path: '/list-approve',
  //         component: ListApproveOrder,
  //       },
  //       {
  //         path: '/detail-approve-order-list',
  //         component: DetailApproveOrderList,
  //       },
  //       {
  //         path: '/approve-category-list',
  //         component: user?.plantCode == 1000 ? ApproveCategoryLits : null,
  //       },
  //       {
  //         path: '/approve-category-detail/:id',
  //         component: ApproveCategoryDetail,
  //       },
  //     ];

  const routes = user?.role.includes('nguoi_dat_hang')
    ? [
        { path: '/', component: OderCartList },
        { path: '/sign-in', component: SignInPage, isPublic: true },

        {
          path: '/profile',
          component: ProfilePage,
        },
        // {
        //   path: '/product',
        //   component: ProductListPage,
        // },
        {
          path: '/product/:code',
          component: ProductDetailPage,
        },
        {
          path: '/product-update',
          component: ProductUpdatePage,
        },
        {
          path: '/product-register',
          component: OderCartList,
        },
        {
          path: '/order/tvv-view/:id',
          component: TVVCheckCart,
        },
        {
          path: '/order-product-list/create',
          component: TvvCartList,
        },
        {
          path: '/declare',
          component: DeclarePage,
        },
      ]
    : user?.role.includes('cua_hang_truong')
    ? [
        { path: '/', component: OderCartList },
        { path: '/sign-in', component: SignInPage, isPublic: true },

        {
          path: '/profile',
          component: ProfilePage,
        },
        // {
        //   path: '/product',
        //   component: ProductListPage,
        // },
        {
          path: '/product/:code',
          component: ProductDetailPage,
        },
        {
          path: '/product-update',
          component: ProductUpdatePage,
        },
        {
          path: '/product-register',
          component: OderCartList,
        },
        {
          path: '/order/tvv-view/:id',
          component: TVVCheckCart,
        },
        {
          path: '/order/cht-view/:id',
          component: ChtView,
        },
        {
          path: '/order-product-list/create',
          component: TvvCartList,
        },
        {
          path: '/plants-allocate',
          component: PlantAllocateView,
        },
        {
          path: '/plants-allocate/createCabinet/:id',
          component: PlantDeclareCreateCabinet,
        },
        {
          path: '/plants-allocate/createAllocateGoods/:id',
          component: PlantAllocategoodsCreate,
        },
        // {
        //   path: '/branchs-capital',
        //   component: BranchCapital,
        // },
        {
          // khi nào lắp API thì thêm ID vào
          path: '/branchs-capital-detail',
          component: Allocatedetails,
        },
        {
          path: '/branchs-capital-create/declare',
          component: StepDeclare,
        },
        {
          path: '/branchs-capital-create/list',
          component: StepList,
        },
        {
          path: '/list-approve',
          component: ListApproveOrder,
        },
        {
          path: '/detail-approve-order-list',
          component: DetailApproveOrderList,
        },
        {
          path: '/approve-order-list',
          component: ApproveOrderList,
        },
        {
          path: '/approve-detail',
          component: ApproveDetail,
        },
        {
          path: '/declare',
          component: DeclarePage,
        },
      ]
    : user?.role.includes('asm') ||
      user?.role.includes('rsm') ||
      user?.role.includes('gdcn') ||
      user?.role.includes('cukv') ||
      user?.role.includes('quan_ly') ||
      (user?.role.includes('admin') && user?.plantCode != 1000)
    ? [
        {
          path: '/',
          component:
            user?.plantCode == 1000 ? CategoryManagementPage : OderCartList,
        },
        { path: '/sign-in', component: SignInPage, isPublic: true },
        {
          path: '/role-based-auth',
          component: user?.plantCode == 1000 ? UserManagementPage : null,
        },
        {
          path: '/groups',
          component: GroupsPage,
          isPublic: true,
        },
        {
          path: '/functions',
          component: FunctionPage,
        },
        {
          path: '/job-title',
          component: JobTitlePage,
        },
        {
          path: '/mapping-job-title',
          component: user?.plantCode == 1000 ? MappingJobTitlePage : null,
        },
        {
          path: '/category',
          component: user?.plantCode == 1000 ? CategoryManagementPage : null,
        },
        {
          path: '/add-category/category-info-step/:id?',
          component: CategoryInfoStepPage,
        },
        {
          path: '/add-category/product-list-step/:id?',
          component: ProductListStepPage,
        },
        {
          path: '/add-category/approve-step/:id?',
          component: ApproveStepPage,
        },
        {
          path: '/category/:id',
          component: CategoryInfoPage,
        },
        {
          path: '/profile',
          component: ProfilePage,
        },
        {
          path: '/product',
          component: user?.plantCode == 1000 ? ProductListPage : null,
        },
        {
          path: '/product/:code',
          component: ProductDetailPage,
        },
        {
          path: '/department-approval',
          component: DepartmentApproval,
        },
        {
          path: '/department-approval/edit/:id',
          component: EditApproval,
        },
        {
          path: '/department-approval/addnew',
          component: CreateApproval,
        },
        {
          path: '/department-approval/detail/:id',
          component: ApprovalDetail,
        },
        {
          path: '/brand',
          component: BrandPage,
        },
        {
          path: '/brand/add-brand',
          component: AddBrandPage,
        },
        {
          path: '/brand/edit',
          component: BrandEditlPage,
        },
        {
          path: '/brand/details',
          component: BrandDetailPage,
        },
        {
          path: '/branch-cabinet',
          component: CabinetPage,
        },
        {
          path: '/branch-cabinet/create',
          component: CreateCabinet,
        },
        {
          path: '/recommended-list',
          component: RecommendedListDetail,
        },
        {
          path: '/recommended-list/edit/step1',
          component: Step1,
        },
        {
          path: '/recommended-list/edit/step2',
          component: Step2,
        },
        {
          path: '/declare-cart-info',
          component: DeclareCartInfo,
        },
        {
          path: '/declare-cart-product/:id/:pof_type_code',
          component: DeclareCartProducts,
        },
        {
          path: '/declare-cart-review-info/:id',
          component: DeclareCartReviewInfo,
        },
        {
          path: '/cart-list',
          component: CartList,
        },
        {
          path: '/cart-details/:id',
          component: CartDetailPage,
        },
        {
          path: '/preorder-create-order',
          component: CreateCartInfo,
        },
        {
          path: '/preorder-create-review',
          component: CreateCartReview,
        },
        {
          path: '/product-update',
          component: ProductUpdatePage,
        },
        {
          path: '/product-register',
          component: OderCartList,
        },
        {
          path: '/order/tvv-view/:id',
          component: TVVCheckCart,
        },
        {
          path: '/preorder',
          component: PreOrderListPage,
        },
        {
          path: '/preorder/edit/:plantId/:cartRegisterId',
          component: EditCartPage,
        },
        {
          path: '/order',
          component: ChtCartList,
        },
        {
          path: '/branchs-capital',
          component: user?.role.includes('admin') ? BranchCapital : null,
        },
        {
          path: '/plants-allocate',
          component: PlantAllocateView,
        },
        {
          path: '/plants-allocate/createCabinet/:id',
          component: PlantDeclareCreateCabinet,
        },
        {
          path: '/plants-allocate/createAllocateGoods/:id',
          component: PlantAllocategoodsCreate,
        },
        {
          path: '/store-info',
          component: StoreInfo,
        },
        {
          // khi nào lắp API thì thêm ID vào
          path: '/branchs-capital-detail',
          component: Allocatedetails,
        },
        {
          path: '/branchs-capital-create/declare',
          component: StepDeclare,
        },
        {
          path: '/branchs-capital-create/list',
          component: StepList,
        },
        {
          path: '/order/cht-view/:id',
          component: ChtView,
        },
        {
          path: '/order-product-list/create',
          component: TvvCartList,
        },
        {
          path: '/approve-order-list',
          component: ApproveOrderList,
        },
        {
          path: '/approve-detail',
          component: ApproveDetail,
        },
        {
          path: '/declare',
          component: DeclarePage,
        },
        {
          path: '/list-approve',
          component: ListApproveOrder,
        },
        {
          path: '/detail-approve-order-list',
          component: DetailApproveOrderList,
        },
        {
          path: '/approve-category-list',
          component: user?.plantCode == 1000 ? ApproveCategoryLits : null,
        },
        {
          path: '/approve-category-detail/:id',
          component: ApproveCategoryDetail,
        },
      ]
    : user?.plantCode == 1000
    ? [
        {
          path: '/',
          component:
            user?.plantCode == 1000 ? CategoryManagementPage : OderCartList,
        },
        { path: '/sign-in', component: SignInPage, isPublic: true },
        {
          path: '/role-based-auth',
          component: UserManagementPage,
        },
        {
          path: '/groups',
          component: GroupsPage,
          isPublic: true,
        },
        {
          path: '/functions',
          component: FunctionPage,
        },
        {
          path: '/job-title',
          component: JobTitlePage,
        },
        {
          path: '/mapping-job-title',
          component: MappingJobTitlePage,
        },
        {
          path: '/category',
          component: user?.plantCode == 1000 ? CategoryManagementPage : null,
        },
        {
          path: '/add-category/category-info-step/:id?',
          component: CategoryInfoStepPage,
        },
        {
          path: '/add-category/product-list-step/:id?',
          component: ProductListStepPage,
        },
        {
          path: '/add-category/approve-step/:id?',
          component: ApproveStepPage,
        },
        {
          path: '/category/:id',
          component: CategoryInfoPage,
        },
        {
          path: '/profile',
          component: ProfilePage,
        },
        {
          path: '/product',
          component: user?.plantCode == 1000 ? ProductListPage : null,
        },
        {
          path: '/product/:code',
          component: ProductDetailPage,
        },
        {
          path: '/department-approval',
          component: DepartmentApproval,
        },
        {
          path: '/department-approval/edit/:id',
          component: EditApproval,
        },
        {
          path: '/department-approval/addnew',
          component: CreateApproval,
        },
        {
          path: '/department-approval/detail/:id',
          component: ApprovalDetail,
        },
        {
          path: '/brand',
          component: BrandPage,
        },
        {
          path: '/brand/add-brand',
          component: AddBrandPage,
        },
        {
          path: '/brand/edit',
          component: BrandEditlPage,
        },
        {
          path: '/brand/details',
          component: BrandDetailPage,
        },
        {
          path: '/branch-cabinet',
          component: CabinetPage,
        },
        {
          path: '/branch-cabinet/create',
          component: CreateCabinet,
        },
        {
          path: '/recommended-list',
          component: RecommendedListDetail,
        },
        {
          path: '/recommended-list/edit/step1',
          component: Step1,
        },
        {
          path: '/recommended-list/edit/step2',
          component: Step2,
        },
        {
          path: '/declare-cart-info',
          component: DeclareCartInfo,
        },
        {
          path: '/declare-cart-product/:id/:pof_type_code',
          component: DeclareCartProducts,
        },
        {
          path: '/declare-cart-review-info/:id',
          component: DeclareCartReviewInfo,
        },
        {
          path: '/cart-list',
          component: CartList,
        },
        {
          path: '/cart-details/:id',
          component: CartDetailPage,
        },
        {
          path: '/preorder-create-order',
          component: CreateCartInfo,
        },
        {
          path: '/preorder-create-review',
          component: CreateCartReview,
        },
        {
          path: '/product-update',
          component: ProductUpdatePage,
        },
        {
          path: '/product-register',
          component: OderCartList,
        },
        {
          path: '/order/tvv-view/:id',
          component: TVVCheckCart,
        },
        {
          path: '/preorder',
          component: PreOrderListPage,
        },
        {
          path: '/preorder/edit/:plantId/:cartRegisterId',
          component: EditCartPage,
        },
        {
          path: '/order',
          component: ChtCartList,
        },
        {
          path: '/branchs-capital',
          component: user?.role.includes('admin') ? BranchCapital : null,
        },
        {
          path: '/plants-allocate',
          component: PlantAllocateView,
        },
        {
          path: '/plants-allocate/createCabinet/:id',
          component: PlantDeclareCreateCabinet,
        },
        {
          path: '/plants-allocate/createAllocateGoods/:id',
          component: PlantAllocategoodsCreate,
        },
        {
          path: '/store-info',
          component: StoreInfo,
        },
        {
          // khi nào lắp API thì thêm ID vào
          path: '/branchs-capital-detail',
          component: Allocatedetails,
        },
        {
          path: '/branchs-capital-create/declare',
          component: StepDeclare,
        },
        {
          path: '/branchs-capital-create/list',
          component: StepList,
        },
        {
          path: '/order/cht-view/:id',
          component: ChtView,
        },
        {
          path: '/order-product-list/create',
          component: TvvCartList,
        },
        {
          path: '/approve-order-list',
          component: ApproveOrderList,
        },
        {
          path: '/approve-detail',
          component: ApproveDetail,
        },
        {
          path: '/declare',
          component: DeclarePage,
        },
        {
          path: '/list-approve',
          component: ListApproveOrder,
        },
        {
          path: '/detail-approve-order-list',
          component: DetailApproveOrderList,
        },
        {
          path: '/approve-category-list',
          component: user?.plantCode == 1000 ? ApproveCategoryLits : null,
        },
        {
          path: '/approve-category-detail/:id',
          component: ApproveCategoryDetail,
        },
      ]
    : [
        { path: '/', component: SignInPage, isPublic: true },
        { path: '/sign-in', component: SignInPage, isPublic: true },
      ];

  return (
    <Switch>
      {routes.map((route) => {
        return route.isPublic ? (
          <Route
            key={route.path}
            path={route.path}
            exact
            component={route.component}
          />
        ) : (
          <ProtectedRoute
            key={route.path}
            path={route.path}
            exact
            component={route.component}
          />
        );
      })}
    </Switch>
  );
};

export default Routes;
